export default __webpack_public_path__ + "static/Banner-Galentine-2-1b78d02651a9b917f85ba126dc7c0b5e.jpg";